<h1>Reveleer Icons</h1>

<div class="input-container">
  <div>Width <input type="number" step="20" [(ngModel)]="logoWidth" /></div>
  <div>Height <input type="number" step="20" [(ngModel)]="logoHeight" /></div>
  <div>Font Color <input [(ngModel)]="fontColor" /></div>
  <div>BgColor <input [(ngModel)]="backgroundColor" /></div>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-icon"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-icon--transparent"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-text"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-text--white"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-text--red"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-horizontal"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-vertical"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="mrcs-icon" iconType="mrcs-icon" iconName="play-recording"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="mrcs-icon" iconType="mrcs-icon" iconName="dialpad"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="iconStyles">
  <app-icon iconStyle="pi" iconType="pi" iconName="ellipsis-v"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="iconStyles">
  <app-icon iconStyle="pi" iconType="pi" iconName="filter"></app-icon>
</div>

<h2>MRCS Icons (OLD)</h2>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="mrcs-icon" iconType="mrcs-icon" iconName="logo-short"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="mrcs-icon" iconType="mrcs-icon" iconName="logo-medium"></app-icon>
</div>

<div class="mrcs-icon" [ngStyle]="svgStyles">
  <app-icon iconStyle="mrcs-icon" iconType="mrcs-icon" iconName="logo-long"></app-icon>
</div>


<div class="mrcs-icon" [ngStyle]="deskBackgroundStyles">
  <app-icon iconStyle="mrcs-icon" iconType="mrcs-icon" iconName="desk-background"></app-icon>
</div>